'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export const useGlobalScreenHeight = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
};
function _temp() {
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  document.documentElement.style.setProperty("--svh", `${vh}px`);
}
function _temp2() {
  const setGlobalScreenHeight = _temp;
  setGlobalScreenHeight();
}